// betonijerry/src/utils/auth/logoutTeardown.js
// Pure decision for what a logout must tear down. Betonijerry's logout is the
// app's ONLY server-side logout (and its app-wide 401 handler), so it revokes
// every token the browser holds — including the 7-day admin token stashed while
// impersonating (fb#98: leaving it valid was a token-theft window). Kept pure so
// the rule is unit-tested without a real JWT / fetch; AuthContext decodes the
// imp claim and executes the returned plan (all revokes are fire-and-forget).

/**
 * @param {object} args
 * @param {string|null} args.activeToken - The current session token (imp token while impersonating).
 * @param {boolean} args.activeIsImpersonation - Whether activeToken carries an `imp` claim.
 * @param {string|null} args.stashToken - The stashed admin token, if impersonating.
 * @returns {{ endImpersonation: boolean, tokensToRevoke: string[] }}
 */
export function planLogoutTeardown({ activeToken, activeIsImpersonation, stashToken }) {
  const tokensToRevoke = [...new Set([activeToken, stashToken].filter(Boolean))];
  return {
    endImpersonation: Boolean(activeToken && activeIsImpersonation),
    tokensToRevoke,
  };
}
